export class SalonCategories {
  constructor() {
    this.SalonServices = document.querySelectorAll(".js-salon-categories");
    this.SalonServicesNew = document.querySelector(".js-new-salon-categories");
    this.initServices();
  }

  initServices() {
    if (this.SalonServices){
      this.SalonServices.forEach(SalonService => {
        const buttons = SalonService.querySelectorAll(".js-menu-button");

        if (buttons.length > 0) {
          buttons[buttons.length - 1].classList.add("SalonCategories--border");
        }

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const category = button.dataset.category;
            const card = SalonService.querySelector(
              `.js-category[data-category="${category}"]`
            );

            if (card) {
              card.classList.toggle("hidden");

              if (card.classList.contains("hidden")) {
                button.classList.remove("SalonCategories--active");
              } else {
                button.classList.add("SalonCategories--active");
              }
            }
          });
        });
      });
    }

    if (this.SalonServicesNew) {
      const categoryWeCarryNew = document.querySelector("#SalonCategories-new");
      if (!categoryWeCarryNew) return;
      const categoryButtons = this.SalonServicesNew.querySelectorAll(
        ".js-category-button"
      );

      if (categoryButtons.length > 0) {
        categoryButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const categoryId = button.dataset.category;
            const categoryWrapper = button.closest(
              ".SalonCategories-categoryWrapper"
            );
            const subcategories = this.SalonServicesNew.querySelector(
              `.js-subcategories[data-category="${categoryId}"]`
            );

            if (subcategories) {
              const isHidden = subcategories.classList.contains("hidden");

              this.SalonServicesNew.querySelectorAll(
                ".js-subcategories"
              ).forEach((subcat) => {
                subcat.classList.add("hidden");
                subcat.classList.remove(
                  "SalonCategories-subcategories--expanded"
                );
              });

              this.SalonServicesNew.querySelectorAll(
                ".SalonCategories-categoryWrapper"
              ).forEach((wrapper) =>
                wrapper.classList.remove("has-subcategories")
              );

              this.SalonServicesNew.querySelectorAll(
                ".SalonCategories-categoryItem"
              ).forEach((item) => item.classList.remove("is-active"));

              if (isHidden) {
                subcategories.style.left = `-${
                  button.getBoundingClientRect().left -
                  categoryWeCarryNew.getBoundingClientRect().left
                }px`;
                subcategories.classList.remove("hidden");
                subcategories.classList.add(
                  "SalonCategories-subcategories--expanded"
                );

                const categoryItem = categoryWrapper ? categoryWrapper.querySelector(".SalonCategories-categoryItem") : null;

                if (categoryItem) {
                  categoryItem.classList.add("is-active");
                }

                if (categoryWrapper) {
                  categoryWrapper.classList.add("has-subcategories");
                }
              }
            }
          });
        });
      }
    }
  }
}
